<template>
  <v-app>
    <snackbar ref="snackbar"></snackbar>

    <v-navigation-drawer
      v-model="drawer"
      app
      class="navigation-drawer-bg"
      dark
      :mini-variant.sync="mini"
    >
      <v-list-item
        class="px-2"
        dark
        @click.stop="mini = !mini"
      >
        <v-list-item-avatar color="blue-grey lighten-5" :class="{'avatar-shadow': user.avatar}">
          <img
            v-if="user.avatar"
            :src="`${baseURL}/${user.avatar}`"
            :alt="user.name"
          >
          <span v-else class="body-2 blue-grey--text text--darken-1 font-weight-regular mx-auto">{{ user | fullName | capitalizeName }}</span>
        </v-list-item-avatar>
        <v-list-item-title>{{ user | fullName }}</v-list-item-title>
        <v-btn icon>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense dark class="mt-n2">
        <v-list-item
          v-if="isAdmin"
          link
          :to="{ name: 'dashboard' }"
          exact
          :class="{'opacity-06': $route.name !== 'dashboard'}"
        >
          <v-list-item-action>
            <v-icon>mdi-view-grid-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="isAdmin"
          link
          :to="{ name: 'awards.index' }"
          :class="{'opacity-06': isNotActiveRoute('awards')}"
        >
          <v-list-item-action>
            <v-icon>mdi-trophy-variant-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Awards
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-else
          link
          :to="{ name: 'awards.edit' , params: { id: user.award.id } }"
          :class="{'opacity-06': isNotActiveRoute('awards')}"
        >
          <v-list-item-action>
            <v-icon>mdi-trophy-variant-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Award
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="isAdmin"
          link
          :to="{ name: 'laureates.index' }"
          :class="{'opacity-06': isNotActiveRoute('laureates')}"
        >
          <v-list-item-action>
            <v-icon>mdi-account-group-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Laureates
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="isAdmin"
          link
          :to="{ name: 'users.index' }"
          :class="{'opacity-06': isNotActiveRoute('users')}"
        >
          <v-list-item-action>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Users
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item class="opacity-06" @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="$route.name === 'dashboard' && !scrollY && $vuetify.breakpoint.mdAndUp ? 'transparent' : $route.name === 'dashboard' && scrollY && $vuetify.breakpoint.mdAndUp ? 'primary' : 'white'"
      dense
      :flat="$route.name === 'dashboard' && !scrollY"
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndDown"
        @click.stop="drawer = !drawer"
        color="primary"
      ></v-app-bar-nav-icon>

      <v-toolbar-title
        v-if="$route.name !== 'users.index'"
      >
        <div
          v-if="$route.name === 'dashboard'"
          class="white--text text-h6"
        >
          <span class="the-digest">The Digest</span>
          <span class="hidden-sm-and-down"> of Human Rights Awards</span>
        </div>
        <div v-else>
          <span class="primary--text">{{ $route.meta.title }}</span>
        </div>
      </v-toolbar-title>

      <v-tabs
        v-else
        centered
        active-class="primary--text"
        slider-color="secondary"
      >
        <v-tab
          @click="setUsersTab('tab-active')"
        >
          Active
        </v-tab>
        <v-tab
          @click="setUsersTab('tab-pending')"
        >
          Pending
        </v-tab>
      </v-tabs>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main class="grey lighten-5">
<!--       <icon-base
        width="200"
        height="200"
        color="red"
      >
        <icon-laureates/>
      </icon-base> -->
<!--       <v-container
        class="fill-height"
        fluid
      > -->
<!--         <v-row
          align="center"
          justify="center"
        > -->
          <router-view></router-view>
        <!-- </v-row> -->
      <!-- </v-container> -->
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar'
import { mapGetters } from 'vuex'

export default {
  props: {
    source: String
  },

  components: {
    Snackbar
  },

  data: () => ({
    drawer: null,
    mini: true,
    scrollY: 0
  }),

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  filters: {
    fullName: function (value) {
      if (!value) return ''
      return `${value.first_name} ${value.last_name}`
    },

    capitalizeName: function (value) {
      if (!value) return ''
      const name = value.toString().split(' ')
      return name.length > 1 ? name[0].charAt(0).toUpperCase() + name[1].charAt(0).toUpperCase() : name[0].charAt(0).toUpperCase()
    }
  },

  computed: {
    ...mapGetters([
      'isAdmin',
      'user',
      'usersTab'
    ])
  },

  methods: {
    handleScroll (event) {
      this.scrollY = window.scrollY
    },

    isNotActiveRoute (route) {
      return this.$route.name !== route + '.index' && this.$route.name !== route + '.create' && this.$route.name !== route + '.edit'
    },

    logout () {
      this.$store.dispatch('logout')
    },

    setUsersTab (val) {
      this.$store.commit('SET_USERS_TAB', val)
    }
  }
}
</script>

<style scoped>
  .navigation-drawer-bg >>> .v-list-item--active .v-list-item__action,
  .navigation-drawer-bg >>> .v-list-item--active .v-list-item__title {
    color: #f2d046;
  }
</style>
